module.exports = __webpack_public_path__ + "media/images/common/purchase_btn-d12c7872ad742704c660a19403458dff.png";